






































































































import { defineComponent, PropType } from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccStar from "@/components/Atoms/OccStar/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import { formatDate } from "@/helpers/date-helper";
import { ApiResponse, Order } from "@/api/types";
import { useRouter } from "@/router";
import { getDisplaySelectionStatus } from "@/helpers/agentScoutAcceptances";

export interface Props {
  agentScoutAcceptances: ApiResponse.AgentScoutAcceptance[];
}

export default defineComponent({
  name: "AcceptanceTable",
  components: {
    OccLabel,
    OccButton,
    OccStar,
    ListTable
  },
  props: {
    agentScoutAcceptances: {
      type: Array as PropType<Props["agentScoutAcceptances"]>,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const router = useRouter();

    const goToAgentScoutAcceptance = (_: Event, index: number) => {
      const agentScoutAcceptance = props.agentScoutAcceptances[index].user;
      try {
        const userDetailRoute = router.resolve({
          name: "AgentScoutAcceptance",
          params: { user_id: String(agentScoutAcceptance.id) }
        });
        window.open(userDetailRoute.href, "_blank", "noopener");
      } catch (e) {
        return;
      }
    };

    const onChangeOrder = (order: Order, headerIndex: number) => {
      emit("changeOrder", order, headerIndex);
    };

    return {
      formatDate,
      goToAgentScoutAcceptance,
      onChangeOrder,
      getDisplaySelectionStatus
    };
  }
});
